export const periodProducts = ['box-builder', 'tampon-box', 'pad-box', 'liners-box'];
